import { useState } from "react";
import { IoLocationOutline } from "react-icons/io5";
import { FaEuroSign, FaHome } from "react-icons/fa";
import { Gi3dStairs } from "react-icons/gi";
import { IoResize } from "react-icons/io5";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { useGetAllhousingCustomerQuery } from "../../../app/features/housing/housingApi";
import { useGetAllCityQuery } from "../../../app/features/account/accountApi";
import LoadingUi from "../../../components/LoadingUi/LoadingUi";
import config from "../../../config";
import { setCurrentUser } from "../../../app/features/auth/authSlice";
import { useAppSelector } from "../../../app/hooks";
import SEOData from "../../../components/SEO/SEO";
import seoImage from "../../../assets/SocialShare/crop.png";

const HousingPages = () => {
  const [moveInDate, setMoveInDate] = useState(null);
  const [priceRange, setPriceRange] = useState(200);
  const navigate = useNavigate();

  const user = useAppSelector(setCurrentUser);
  // console.log(user);

  // Default price set at 1500
  const countries = [
    { value: "Finland", label: "Finland" },
    { value: "Bangladesh", label: "Bangladesh" },
  ];
  // const handlePriceChange = (event) => {
  //   setPriceRange(event.target.value);
  // };

  // Calculate percentage for the selected range (min: 500, max: 3000)
  const percentage = ((priceRange - 200) / (3000 - 200)) * 100;

  const [filters, setFilters] = useState({
    type: "", // full or shared
    priceRange: "",
    rooms: "",
    city: "", // new city filter
  });

  // console.log(filters);

  const {
    data: housing,
    isLoading: housingLoading,
    error: housingError,
  } = useGetAllhousingCustomerQuery();
  const {
    data: cityData,
    error: cityError,
    isLoading: cityLoading,
  } = useGetAllCityQuery();

  const cityLocation = cityData?.map((country) => ({
    value: country.id,
    label: country.name,
  }));

  const getCityName = (cityId) => {
    const city = cityData?.find((city) => city.id === cityId);
    return city?.name;
  };

  // console.log(filters);

  // console.log(housing?.results);

  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  const handlePriceChange = (e) => {
    const value = e.target.value;
    setPriceRange(value);
    setFilters((prevFilters) => ({
      ...prevFilters,
      priceRange: value,
    }));
  };

  const filteredApartments = housing?.results?.filter((apartment) => {
    return (
      (filters.type ? apartment?.types === filters?.type : true) &&
      (filters.priceRange
        ? apartment?.details?.rent_per_month <= filters.priceRange
        : true) &&
      (filters.rooms
        ? filters.rooms === "3+"
          ? apartment?.details?.rooms >= 3
          : apartment?.details?.rooms == filters.rooms
        : true) &&
      (filters.city ? apartment?.city === filters.city : true) &&
      (moveInDate
        ? new Date(apartment?.details?.rent_start_date) >= moveInDate
        : true)
    );
  });

  // console.log(obfuscateId(11))

  const handleViewDetails = (id) => {
    const hashedId = CryptoJS.AES.encrypt(
      id.toString(),
      config.secretKey
    ).toString();
    const url = `/housing/${encodeURIComponent(hashedId)}`;
    window.open(url, "_blank");
  };

  const handleFindHouse = () => {
    if (!user?.email) {
      navigate("/sign-in", { state: "/student/findHouse" });
    } else {
      navigate("/student/findHouse");
    }
  };

  const handleClearFilter = () => {
    setFilters({
      type: "", // full or shared
      priceRange: "",
      rooms: "",
      city: "", // new city filter
    });
    setMoveInDate(null);
    setPriceRange(200);
    window.location.reload();
  };

  if (housingLoading && cityLoading) {
    return <LoadingUi />;
  }
  // console.log(filteredApartments);

  if (housing?.results.length === 0) {
    return (
      <div className="bg-slate-100 w-full h-full">
        <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
          {/* Icon */}
          <div className="mb-6">
            <div className="w-24 h-24 bg-gray-200 rounded-full flex items-center justify-center">
              <FaHome className="text-gray-500 w-16 h-16" />
            </div>
          </div>

          {/* Main message */}
          <h1 className="text-2xl font-semibold text-gray-800 mb-2">
            No Houses Available
          </h1>
          <p className="text-lg text-gray-700 mb-4">
            Currently, no houses are available.
          </p>
          <p className="text-gray-600 text-center mb-8">
            Please check back later or contact support for more details.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className=" bg-[#f5e2e2c0] ">
      <div className="flex flex-col md:flex-row gap-6 p-6  max-w-[1200px]  mx-auto min-h-screen -z-10">
        <SEOData
          title={`UniEdu || Housing`}
          description={`All year long, the Community hosts exciting events to energize and strengthen your leadership. 
            Get to know CBC through a Local Group, or join leaders from around the globe.`}
          canonical={window.location.href}
          image={`https://uniedu.fi${seoImage}`}
        />
        {/* Filter Section */}
        <div className="w-full md:w-1/4 bg-gradient-to-br from-white to-gray-50 p-6 rounded-xl shadow-lg border h-fit border-gray-200 overflow-y-auto">
          <h2 className="text-2xl font-semibold mb-6 text-gray-800">
            Filter Apartments
          </h2>

          <div className="mb-5">
            <label className="block text-gray-700 font-medium mb-2">
              Apartment Type
            </label>
            <div className="flex flex-col space-y-2">
              <label className="flex items-center cursor-pointer py-1 min-h-[40px]">
                <input
                  type="radio"
                  name="type"
                  value=""
                  onChange={handleFilterChange}
                  className="hidden peer"
                />
                <span className="w-5 h-5 inline-block mr-3 border-2 border-gray-300 rounded-full peer-checked:bg-blue-500 peer-checked:border-transparent flex-shrink-0"></span>
                All Types
              </label>
              <label className="flex items-center cursor-pointer py-1 min-h-[40px]">
                <input
                  type="radio"
                  name="type"
                  value="full"
                  onChange={handleFilterChange}
                  className="hidden peer"
                />
                <span className="w-5 h-5 inline-block mr-3 border-2 border-gray-300 rounded-full peer-checked:bg-blue-500 peer-checked:border-transparent flex-shrink-0"></span>
                Full Apartment
              </label>
              <label className="flex items-center cursor-pointer py-1 min-h-[40px]">
                <input
                  type="radio"
                  name="type"
                  value="shared"
                  onChange={handleFilterChange}
                  className="hidden peer"
                />
                <span className="w-5 h-5 inline-block mr-3 border-2 border-gray-300 rounded-full peer-checked:bg-blue-500 peer-checked:border-transparent flex-shrink-0"></span>
                Shared Apartment
              </label>
            </div>
          </div>

          <div className="mb-5">
            <label className="block text-gray-700 font-medium mb-2">
              Rooms
            </label>
            <div className="flex flex-col space-y-2">
              <label className="flex items-center cursor-pointer py-1 min-h-[40px]">
                <input
                  type="radio"
                  name="rooms"
                  value=""
                  onChange={handleFilterChange}
                  className="hidden peer"
                />
                <span className="w-5 h-5 inline-block mr-3 border-2 border-gray-300 rounded-full peer-checked:bg-blue-500 peer-checked:border-transparent flex-shrink-0"></span>
                All
              </label>
              <label className="flex items-center cursor-pointer py-1 min-h-[40px]">
                <input
                  type="radio"
                  name="rooms"
                  value="1"
                  onChange={handleFilterChange}
                  className="hidden peer"
                />
                <span className="w-5 h-5 inline-block mr-3 border-2 border-gray-300 rounded-full peer-checked:bg-blue-500 peer-checked:border-transparent flex-shrink-0"></span>
                1 Rooms
              </label>
              <label className="flex items-center cursor-pointer py-1 min-h-[40px]">
                <input
                  type="radio"
                  name="rooms"
                  value="2"
                  onChange={handleFilterChange}
                  className="hidden peer"
                />
                <span className="w-5 h-5 inline-block mr-3 border-2 border-gray-300 rounded-full peer-checked:bg-blue-500 peer-checked:border-transparent flex-shrink-0"></span>
                2 Rooms
              </label>
              <label className="flex items-center cursor-pointer py-1 min-h-[40px]">
                <input
                  type="radio"
                  name="rooms"
                  value="3"
                  onChange={handleFilterChange}
                  className="hidden peer"
                />
                <span className="w-5 h-5 inline-block mr-3 border-2 border-gray-300 rounded-full peer-checked:bg-blue-500 peer-checked:border-transparent flex-shrink-0"></span>
                3 Rooms
              </label>
              <label className="flex items-center cursor-pointer py-1 min-h-[40px]">
                <input
                  type="radio"
                  name="rooms"
                  value="3+"
                  onChange={handleFilterChange}
                  className="hidden peer"
                />
                <span className="w-5 h-5 inline-block mr-3 border-2 border-gray-300 rounded-full peer-checked:bg-blue-500 peer-checked:border-transparent flex-shrink-0"></span>
                3 or More Rooms
              </label>
            </div>
          </div>

          {/* Calendar for Move-In Date */}
          <div className="mb-5 w-full">
            <label className="block text-gray-700 font-medium mb-2">
              Move-In Date
            </label>
            <DatePicker
              selected={moveInDate}
              onChange={(date) => setMoveInDate(date)} // Update the moveInDate state
              dateFormat="yyyy/MM/dd"
              placeholderText="Select a date"
              className="w-full p-3 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 ease-in-out"
            />
          </div>

          <div className="mb-5">
            <label className="block text-gray-700 font-medium mb-2">City</label>

            <div>
              <Select
                className="basic-single"
                classNamePrefix="select"
                defaultValue={cityLocation?.value}
                name="city"
                onChange={(selectedOption) => {
                  setFilters({
                    ...filters,
                    city: selectedOption?.value,
                  });
                }}
                options={cityLocation}
                isClearable
              />
            </div>
          </div>

          <div className="mb-5">
            <label className="block text-gray-700 font-medium mb-2">
              Price Range
            </label>
            <input
              type="range"
              name="priceRange"
              min="200" // Set minimum value to 200
              max="3000"
              step="100"
              value={priceRange}
              onChange={handlePriceChange}
              className="w-full h-2 rounded-lg appearance-none cursor-pointer"
              style={{
                background: `linear-gradient(to right, #3b82f6 ${percentage}%, #e5e7eb ${percentage}%)`,
              }}
            />
            <div className="mt-2 text-gray-700 text-sm">
              Up to &euro; {priceRange}
            </div>

            <div>
              <button
                onClick={handleClearFilter}
                className="bg-red-400 text-white px-6 py-[6px] rounded mt-2"
              >
                Clear Filter
              </button>
            </div>
          </div>

          <div className=" mt-6">
            <h1 className="text-xl text-btnColor-400 font-semibold">
              Request us for a housing
            </h1>
            <button
              onClick={handleFindHouse}
              className="mt-2 w-[150px] py-2 text-white rounded text-sm bg-btnColor-400"
            >
              Go For Request{" "}
            </button>
          </div>
        </div>

        {/* Cards Section */}
        <div className="w-full md:w-3/4    grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 ">
          {filteredApartments?.map((apartment) => (
            <div
              key={apartment.id}
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300 flex flex-col"
            >
              <Swiper
                navigation={true}
                pagination={{ clickable: true }}
                modules={[Navigation, Pagination]}
                className="mySwiper"
              >
                {apartment?.images.map((image, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={image?.image}
                      alt={`Product Image ${index + 1}`}
                      className="w-full h-[200px] object-cover"
                    />
                  </SwiperSlide>
                ))}
              </Swiper>

              <div
                className="cursor-pointer"
                onClick={() => handleViewDetails(apartment?.id)}
              >
                <div className="p-6 ">
                  <h3 className="text-xl font-bold text-gray-700">
                    {apartment.name}
                  </h3>
                  <p className=" text-gray-600">
                    <span className="text-gray-800 font-light flex items-center  gap-1 text-sm mt-1">
                      <IoLocationOutline />
                      {apartment.location}, {getCityName(apartment?.city)}
                    </span>
                  </p>
                  <div className="mt-2 text-gray-600 flex justify-between">
                    <span className="text-gray-600 font-light flex items-center gap-2">
                      <FaEuroSign /> {apartment?.details.rent_per_month} /{" "}
                      <span className="text-sm font-light">Month</span>
                    </span>
                    <span className="text-gray-800 flex items-center gap-1">
                      <Gi3dStairs />
                      {apartment?.details?.floor} Floor
                    </span>
                  </div>
                  <div className="mt-2 text-gray-600 flex justify-between">
                    <span className="text-gray-600 font-light flex items-center gap-2">
                      <IoResize />
                      {apartment?.apartment_size} Square Metter
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HousingPages;
